import { CreditCardQuestion } from '@hb/domain/steps/financial-obligation';
import { CreditCardStoreService } from '@hb/modules/financial-obligations/credit-card/credit-card-store.service';
import { PreviousButtonComponent } from '@hb/modules';
import { CreditCardMultipleInstallmentsComponent } from '@hb/modules/financial-obligations/credit-card/credit-card-multiple-installments/credit-card-multiple-installments.component';
import { CreditCardAmountComponent } from '@hb/modules/financial-obligations/credit-card/credit-card-amount/credit-card-amount.component';
import { CreditCardTipComponent } from '@hb/modules/financial-obligations/credit-card/credit-card-tip/credit-card-tip.component';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'credit-card',
    templateUrl: './credit-card.component.html',
    imports: [
        PreviousButtonComponent,
        CreditCardMultipleInstallmentsComponent,
        ApContentPipe,
        CreditCardAmountComponent,
        CreditCardTipComponent
    ],
    styleUrls: ['../../global/global.scss']
})
export class CreditCardComponent implements OnInit, OnDestroy {
    protected readonly store = inject(CreditCardStoreService);
    protected activeQuestion: CreditCardQuestion;
    protected activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy(): void {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showMultipleInstallments(): boolean {
        return (
            this.activeQuestion === CreditCardQuestion.SEVERAL_INSTALLMENTS ||
            (this.store.isActiveQuestion(CreditCardQuestion.SEVERAL_INSTALLMENTS) && this.store.isSummary)
        );
    }
    showCreditCardAmount(): boolean {
        return (
            this.activeQuestion === CreditCardQuestion.AMOUNT ||
            (this.store.isActiveQuestion(CreditCardQuestion.AMOUNT) && this.store.isSummary)
        );
    }
    showTip(): boolean {
        return this.activeQuestion === CreditCardQuestion.TIP && !this.store.isSummary;
    }
}
